import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { Tooltip, sendClickSoundCommand, sendHoverSoundCommand } from 'react-wot-bootstrap'

import { SCHEDULE_TITLE, SCHEDULE_TOOLTIP, SCHEDULE_HAS_CHANGES } from 'containers/Schedule/shared_translations.jsx'

import styles from './BattlesButton.scss'

const ScheduleButton = (props) => {
    const className = classNames(styles.schedule, {
        [styles.schedule__primary]: props.primary,
    })
    const tooltipId = 'sheduleIconTooltip'

    const onClick = () => {
        sendClickSoundCommand()
        props.onClick()
    }

    return (
        <button
            className={className}
            onClick={onClick}
            onMouseEnter={sendHoverSoundCommand}
            data-tip
            data-for={tooltipId}
        >
            <div className={styles.icon} />
            {
                props.primary &&
                <span className={styles.glow}></span>
            }
            {
                props.showBubble &&
                <div className={styles.schedule__bubble}>{'!'}</div>
            }

            <Tooltip id={tooltipId}>
                <div className={styles.tooltipContent}>
                    <p className={styles.tooltipSubtitle}>{SCHEDULE_TITLE}</p>

                    {props.showBubble && (
                        <p className={styles.tooltipMessage}>{SCHEDULE_HAS_CHANGES}</p>
                    )}
                    <p className={styles.tooltipMessage}>{SCHEDULE_TOOLTIP}</p>
                </div>
            </Tooltip>
        </button>
    )
}

ScheduleButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    primary: PropTypes.bool,
    showBubble: PropTypes.bool.isRequired,
}

ScheduleButton.defaultProps = {
    showBubble: false,
}

export default ScheduleButton



// WEBPACK FOOTER //
// ./containers/ClanPanel/components/BattlesButton/ScheduleButton.jsx